import createIcon from '../../createIcon';

/**
 * @component @name NoMeetingRoom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNjM0OCAxMC4zNjQ4SDEwLjYzNDhWMTIuMzY0OEgxMi42MzQ4VjExLjM2NDhMMjIuMzY0OCAyMS4wOTQ4TDIxLjA5NDggMjIuMzY0OEwxNC42MzQ4IDE1LjkwNDhWMjAuMzY0OEgzLjYzNDc3VjE4LjM2NDhINS42MzQ3N1Y2LjkwNDc3TDEuNjM0NzcgMi45MDQ3N0wyLjkwNDc3IDEuNjM0NzdMMTEuNjM0OCAxMC4zNjQ4Wk0xNC42MzQ4IDEwLjg1NDhMNi4xNDQ3NyAyLjM2NDc3SDE0LjYzNDhWMy4zNjQ3N0gxOS42MzQ4VjE1Ljg1NDhMMTcuNjM0OCAxMy44NTQ4VjUuMzY0NzdIMTQuNjM0OFYxMC44NTQ4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoMeetingRoom = createIcon('NoMeetingRoom', [
  [
    'path',
    {
      d: 'M11.6348 10.3648H10.6348V12.3648H12.6348V11.3648L22.3648 21.0948L21.0948 22.3648L14.6348 15.9048V20.3648H3.63477V18.3648H5.63477V6.90477L1.63477 2.90477L2.90477 1.63477L11.6348 10.3648ZM14.6348 10.8548L6.14477 2.36477H14.6348V3.36477H19.6348V15.8548L17.6348 13.8548V5.36477H14.6348V10.8548Z',
      key: 'ta8ql2',
    },
  ],
]);

export default NoMeetingRoom;
